import { useLayoutEffect } from "react";
const useStickyElement = (container, element) => {
  function handlePositionChange() {
    if ((container == null ? void 0 : container.current) && (element == null ? void 0 : element.current)) {
      element.current.style.transform = `translateY(${container.current.scrollTop}px)`;
    }
  }
  useLayoutEffect(() => {
    var _a;
    handlePositionChange();
    (_a = container == null ? void 0 : container.current) == null ? void 0 : _a.addEventListener("scroll", handlePositionChange);
    return () => {
      var _a2;
      (_a2 = container == null ? void 0 : container.current) == null ? void 0 : _a2.removeEventListener("scroll", handlePositionChange);
    };
  }, [container == null ? void 0 : container.current]);
};
export {
  useStickyElement
};
